import { FC } from 'react';
import { Skeleton } from 'antd';
import type { TNfDescription } from './index';
import * as Styled from './styles';

type NftDescriptionSkeletonProps = Pick<TNfDescription, 'showLabel'>;

export const NftDescriptionSkeleton: FC<NftDescriptionSkeletonProps> = ({
  showLabel
}) => {
  return (
    <Styled.NftDetailsPlainSection>
      {showLabel && (
        <Styled.NftDetailsPlainSectionTitle>
          <Skeleton.Button
            active
            block
            style={{
              height: 22,
              width: '50%',
              margin: 0
            }}
          />
        </Styled.NftDetailsPlainSectionTitle>
      )}
      <Styled.Description onClick={() => {}}>
        <Skeleton.Button
          active
          block
          style={{
            height: 22,
            width: '100%',
            margin: 0
          }}
        />
      </Styled.Description>
    </Styled.NftDetailsPlainSection>
  );
};
